import { Injectable } from '@angular/core';
import type { RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';

import { Store } from '@ngrx/store';

import {
  AttachmentsDataScope,
  getAttachmentStoreScope,
  AttachmentsActions,
} from '@recruitee/attachments-data';

@Injectable()
export class RequisitionFilesResolver {
  constructor(private store: Store) {}

  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const id = Number(route.parent?.params.id);
    const scope = getAttachmentStoreScope(AttachmentsDataScope.Requisition, id);

    this.store.dispatch(
      AttachmentsActions.fetchAttachmentsByRequisition({
        payload: {
          params: { requisitionId: id },
          scope,
        },
      }),
    );
    return true;
  }
}
